require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-little-parser.json") })
        }
      }, "path---package-bs-little-parser");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-little-parser!./.cache/json/package-bs-little-parser.json
// module id = 794
// module chunks = 231608221292675